<template >
  <div id="app" class="container-fluid" :style="'font-family:'+font">
    <notifications position="top center" class="notifications-position"/>
    <router-view/>
  </div>
</template>

<script>
// eslint-disable-next-line
export default {
  name: 'App',
  data () {
    return {
      font: this.$store.state.config.mainconfig.font
    };
  },
  beforeMount: async function () {
    // Call api pour récuperer la configuration si elle existe.
    try {
      let httpResponse = await this.$http.get('config/config_vente');
      if (httpResponse.data.errno !== undefined) {
        this.$notify({ type: 'error', title: this.$t('general.errorApi.generalTitle'), text: httpResponse.data.errormsg });
        this.$sentry.captureExceptionWithTags('Got Error when retrieveing config_vente', {'error': httpResponse}, this.$options.name, 'beforeMount');
      }

      if (httpResponse.data.response != null && httpResponse.data.response.val !== undefined) {
        await this.$store.dispatch('config/CONFIG_LOAD', httpResponse.data.response.val);
      }

      if (!this.$store.getters['config/isConfigOk']) {
        this.$sentry.captureExceptionWithTags('Got config_vente but config is not ok', {jsonConfig: this.$store.getters['config/jsonConfig']}, this.$options.name, 'beforeMount');
        this.$notify({
          type: 'error',
          title: this.$t('general.wrongConfigFileTitle'),
          text: this.$t('general.wrongConfigFileMessage')
        });
      }

      // On défini la classe bgColor
      let style = document.createElement('style');
      style.id = 'customColor';
      document.head.appendChild(style);
      this.$setNewAppColor((this.$store.state.config.mainconfig.bgColor) ? this.$store.state.config.mainconfig.bgColor : '#85C33F');
    } catch (err) {
      this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'beforeMount');
      this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: this.$t('general.errorApi.getConfig.errormsg')});
    }
  }
};
</script>

<style>
#app {
  /*overflow:auto;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
body, html {
  height: 100%;
  margin: 0;
  background-color: #FFFFFF;
  font-size: 1em;
}

</style>



// WEBPACK FOOTER //
// src/App.vue